import { Component, OnInit } from '@angular/core';
import { CreateDynamicAsset } from '../../../models/inModels/DynamicAsset';
import { Message } from 'primeng/components/common/message';
import { AuthenticationService } from '../../../services/authentication/authentication.service';
import { Router } from '@angular/router';
import { AssetService } from '../../../services/asset.service';
import { StorageService } from '../../../services/system/storage.service';
import { ConfirmationService } from 'primeng/components/common/confirmationservice';

@Component({
  selector: 'app-create-asset',
  templateUrl: './create-asset.component.html',
  styleUrls: ['./create-asset.component.css']
})
export class CreateAssetComponent implements OnInit {
  model: CreateDynamicAsset;
	loading = false;
	error: Message[];
	uploading = false;
	assets;
  constructor(
		private router: Router,
		private service: AssetService,
		public storageService: StorageService,
  ) { 
    this.model = new CreateDynamicAsset();
  }

  ngOnInit() {
  }

  goBack(): void {
		this.router.navigate(['/assets']);
  }

  save(): void {
    this.loading = true;
    this.service.create(this.model).then(
			result => {
				console.log(result);
				this.loading = false;
				this.goBack();
			},
			error => {
				this.loading = false;
				this.error = [];
				this.error.push({ severity: 'error', summary: 'Error', detail: error });
			});
  }
  isVideo: boolean = false;
  handleWebImage(event): void {
		var result = this.storageService.handleSuccess(event);

		this.model.WebPictureId = result.PublicId;
		this.loading = false;

		if(result.ContentType == "video/mp4"){
			this.isVideo = true;
		} else {
			this.isVideo = false;
		}
	}

  removeWebImage(): void {
		this.model.WebPictureId = null;
		this.loading = false;
	}

  handleMobileImage(event): void {
		var result = this.storageService.handleSuccess(event);

		this.model.MobilePictureId = result.PublicId;
		this.loading = false;
	}

  removeMobileImage(): void {
		this.model.MobilePictureId = null;
		this.loading = false;
	}

  handleError(event): void {
		this.loading = false;
		this.error = [];
		this.storageService.handleError(event, this.error);
	}
}



// WEBPACK FOOTER //
// ./src/app/components/asset/create-asset/create-asset.component.ts